<template>
  <span class="sl--pop">
    <span v-html="heading" />
    <div />
  </span>
</template>

<script>
export default {
  props: ['heading'],
};
</script>

<style lang="scss" scoped>
.sl--pop {
  position: relative;
  z-index: 2;

  span {
    position: relative;
    z-index: 1;
  }

  div {
    content: '';
    position: absolute;
    height: 30px;
    width: 30px;
    bottom: 3px;

    /* transform: translate(0%, -50%); */
    background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='22' height='26' version='1.1' viewBox='0 0 22 26'%3E%3Ctitle%3EPatterns/Burst Copy%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3Cpath id='path-1' d='M8.50740572,16.3350909 C10.1278905,16.640228 15.3161296,18.4160722 14.7241157,18.7192968 C13.7202114,19.2325814 9.26912856,19.4199915 8.03073245,19.3609929 C5.52436846,19.2403898 0.0386465387,17.4518864 0.360730059,15.9414656 C0.682738492,14.4305708 6.886996,16.030428 8.50740572,16.3350909 Z M11.6665692,7.77917752 L11.8450592,8.02107513 C13.4710202,10.2223059 17.6836481,15.9213297 16.3024534,16.2475207 C15.0955967,16.5333144 11.0923651,12.1893541 9.0934237,10.0729902 C7.09450742,7.95710563 2.5956572,2.63983011 4.18159292,1.11281593 C5.73818412,-0.385449746 10.0383727,5.56790155 11.6665692,7.77917752 Z M18.5098315,0.656248744 C20.8041017,0.0801563115 20.5098977,3.90272946 20.7645028,5.21385848 C21.019158,6.52546488 21.4897741,14.2818021 20.4097511,14.6182986 C19.3302054,14.954745 17.444208,6.566735 17.1257405,4.59289099 C17.1257405,4.59289099 16.2149836,1.23143661 18.5098315,0.656248744 Z'/%3E%3C/defs%3E%3Cg id='All' fill='none' fill-rule='evenodd' stroke='none' stroke-width='1'%3E%3Cg id='SeedLegals---%5B02%5D-Start' transform='translate(-417.000000, -2711.000000)'%3E%3Cg id='Patterns/Burst'%3E%3Cg transform='translate(426.500000, 2724.000000) rotate(129.000000) translate(-426.500000, -2724.000000) translate(415.000000, 2714.000000) translate(0.000000, -0.600000)'%3E%3Cmask id='mask-2' fill='%23fff'%3E%3Cuse xlink:href='%23path-1'/%3E%3C/mask%3E%3Cuse id='Mask' fill='%236BA0FF' xlink:href='%23path-1'/%3E%3Cg id='Assets/Colour/Purple' fill='%238887FC' mask='url(%23mask-2)'%3E%3Cg id='Rectangle' transform='translate(1.200000, 0.600000)'%3E%3Crect width='21.903' height='20.16' x='0' y='0'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    right: -35px;
    @screen md {
      right: -40px;
    }
  }
}
</style>
